<template>
  <teleport to="#overlay">
    <div
      v-if="visible"
      class="m-overlay-spinner"
    >
      <m-card>
        <div class="_inner">
          <div class="_loading-screen-text">
            {{ text }}
          </div>
          <m-spinner size="xs" />
        </div>
      </m-card>
    </div>
  </teleport>
</template>

<script setup>
import { onBeforeUnmount, onMounted, ref } from 'vue';

const props = defineProps({
  eventBus: {
    type: Object,
    required: true,
  },
});

const visible = ref(false);
const text = ref('');

const show = ({ text: newText = '' }) => {
  text.value = newText;
  visible.value = true;
};

const hide = () => {
  visible.value = false;
  text.value = '';
};

onMounted(() => {
  props.eventBus.$on('show-overlay-spinner', show);
  props.eventBus.$on('hide-overlay-spinner', hide);
});

onBeforeUnmount(() => {
  props.eventBus.$off('show-overlay-spinner', show);
  props.eventBus.$off('hide-overlay-spinner', hide);
});
</script>

<style scoped lang="scss" type="text/scss">
  .m-overlay-spinner {
    position: fixed;
    top: 0;
    left: 0;
    z-index: 9999;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 100vw;
    height: var(--viewport-height-100);
    background-color: map_get($grey, 'darken-2');

    ._inner {
      display: flex;
      align-items: center;
      justify-content: center;
      min-width: 20rem;

      ._loading-screen-text {
        margin-right: 1rem;
      }
    }
  }
</style>
